import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/modules/general/pages/Index.vue'
import Admin from '@/views/modules/admin_panel/pages/Users.vue'
import UserEdit from '@/views/modules/admin_panel/pages/UserEdit.vue'

import permissioner from '../services/permissioner'

import {case_routes} from "./case/handler.js"
import {project_routes} from "./project/handler.js"


import Login from '@/views/modules/general/pages/Login.vue'

import NoPermission from '@/views/modules/general/pages/NoPermission.vue'

import CRM from '@/views/modules/crm/pages/CRM.vue'
import CRMprofil from '@/views/modules/crm/pages/CRMprofil.vue'
import PersonProfile from '@/views/modules/persons_management/pages/PersonProfile.vue'
import Persons from '@/views/modules/persons_management/pages/Persons.vue'
import Institutions from '@/views/modules/persons_management/pages/Institutions.vue'
import PotentialClients from '@/views/modules/crm/pages/PotentialClients.vue'
import Tarife from '@/views/modules/billing_management/pages/Tarife.vue'
import Sifarnik from '@/views/modules/billing_management/pages/Sifarnik.vue'
import Notes from '@/views/modules/knowledge_management/pages/Notes.vue'
import Billing from '@/views/modules/billing_management/pages/Billing.vue'
import FAQ from '@/views/modules/general/pages/FAQ.vue'

import CalendarGeneral from '@/views/modules/general/pages/CalendarGeneral.vue'
import ComingSoon from '@/views/modules/general/pages/ComingSoon.vue'
import Kontrolna from '@/views/modules/general/pages/Kontrolna.vue'

import Analytics from '@/views/modules/analytics/pages/Analytics.vue'
import Office from '@/views/modules/office_management/pages/Office.vue'

import EnterNewPerson from '@/views/modules/persons_management/forms/EnterNewPerson.vue'
import EnterNewPersonalEvent from '@/views/modules/general/forms/EnterNewPersonalEvent.vue'
import RocistaReport from '@/views/modules/reports/RocistaReport.vue'
import PredmetiReport from '@/views/modules/reports/PredmetiReport.vue'





// PROJECT ROUTES END
import auth from '@/services/auth'

Vue.use(VueRouter)

var routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: '/no-persmission',
    name: 'NoPermission',
    component: NoPermission,
    meta: { requiresAuth: true }
  },
  {
    path: '/personal-profile',
    name: 'UserEdit',
    component: UserEdit,
    meta: { requiresAuth: true }
  },
  {
    path: '/kontrolna',
    name: 'kontrolna',
    component: Kontrolna,
    meta: { requiresAuth: true }
  },
 
  {
    path: '/u-pripremi',
    name: 'ComingSoon',
    component: ComingSoon,
    meta: { requiresAuth: true }
  },

  // All casses routes END
  {
    path: '/crm/',
    name: 'CRM',
    component: CRM,
    meta: { requiresAuth: true }
  },
  {
    path: '/crmprofil/',
    name: 'CRMprofil',
    component: CRMprofil,
    meta: { requiresAuth: true }
  },
  {
    path: '/osobe/fiz/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/fiz/:oib/edit',
    name: 'PhisicalPersonEdit',
    component: EnterNewPerson,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/institucije/:oib/edit',
    name: 'InstitutionEdit',
    component: EnterNewPerson,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
    
  },
  {
    path: '/osobe/law/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/prav/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/prav/:oib/edit',
    name: 'LegalPersonEdit',
    component: EnterNewPerson,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/leg/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/institucije/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/leg-body/:oib',
    name: 'PersonProfile',
    component: PersonProfile,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/osobe/leg-body/:oib/edit',
    name: 'LegalBodyEdit',
    component: EnterNewPerson,
    meta: { requiresAuth: true }
  },
  {
    path: '/osobe/',
    name: 'Persons',
    component: Persons,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/institucije/',
    name: 'institucije',
    component: Institutions,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.read")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/tarife/',
    name: 'Tarife',
    component: Tarife,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.billing.edit")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/sifarnik/',
    name: 'sifarnik',
    component: Sifarnik,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.statuses.edit")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },
  {
    path: '/biljeske/',
    name: 'biljeske',
    component: Notes,
    meta: { requiresAuth: true }
  },
  {
    path: '/naplata/',
    name: 'naplata',
    component: Billing,
    meta: { requiresAuth: true }
  },
  {
    path: '/faq/',
    name: 'faq',
    component: FAQ,
    meta: { requiresAuth: true }
  },
  {
    path: '/potencijalni/',
    name: 'PotentialClients',
    component: PotentialClients,
    meta: { requiresAuth: true }
  },


  {
    path: '/nova-osoba/',
    name: 'EnterNewPerson',
    component: EnterNewPerson,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      // Get user info if it is on reload
      await permissioner.checkUserInfo();
      // Checking if user has the right access to the application view
      if (await permissioner.check_application_permission("application.person.edit")) { 
        next() 
      } else {
        // Did  not satisfy the requirements for accessing the view
        next({ name: 'NoPermission' })
      }
    }
  },


  { //trebamo imati jedan page i za skupni kalendar - privremeno
    path: '/kalendar',
    name: 'CalendarGeneral',
    component: CalendarGeneral,
    meta: { requiresAuth: true }
  },
  {
    path: '/kalendar/novi-osobni-dogadaj',
    name: 'EnterNewPersonalEvent',
    component: EnterNewPersonalEvent,
    meta: { requiresAuth: true }
  },
  {
    path: '/rocista-report',
    name: 'RocistaReport',
    component: RocistaReport,
    meta: { requiresAuth: true }
  },
  {
    path: '/predmeti-report',
    name: 'PredmetiReport',
    component: PredmetiReport,
    meta: { requiresAuth: true }
  },


  {
    path: '/analitika',
    name: 'Analytics',
    component: Analytics,
    meta: { requiresAuth: true }
  },
  {
    path: '/ured',
    name: 'Office',
    component: Office,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },


]


routes = routes.concat(case_routes)
routes = routes.concat(project_routes)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  var currentUser = null;
  if (process.env.VUE_APP_CLIENT_ID) {
    auth.configure(process.env.VUE_APP_CLIENT_ID)

    // Restore any cached or saved local user
    currentUser = auth.user()
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  // console.log(currentUser)

  if (requiresAuth && !currentUser) next("login");
  else if (!requiresAuth && currentUser) next("/");
  else next();
});

export default router;
